import {useState, useCallback, useMemo} from 'react';
import {GoalsController} from '../../../api/goals-api/goals-controller';
import {GoalsRequestImpl} from '../../../api/goals-api/goals-request';
import {useStoreContext} from '../../../store/store-context';
import {useQuery} from 'react-query';
import {useFetchUserGoals} from '@hooks/goals.hook';
import {CompanyCheckinsRequestImpl} from '../company-legacy/company-components/company-checkins/company-checkins.request';
import {CompanyCheckinsController} from '../company-legacy/company-components/company-checkins/company-checkins.controller';

export function useYouHook() {
  const [showUpdateGoalModal, setShowUpdateGoalModal] = useState(false);
  const {
    data,
    refetch,
    searchValue,
    setSearchValue,
    isLoading,
  } = useFetchUserGoals();

  const {
    storeYouGoals: {fetchedGoals},
    checkinsStore: {setCalendarWeeks},
    authStore: {auth},
  } = useStoreContext();

  const handleClose = () => {
    setShowUpdateGoalModal(false);
  };

  const checkinsRequest = useMemo(() => new CompanyCheckinsRequestImpl(), []);
  const checkinsController = useMemo(
    () => new CompanyCheckinsController(checkinsRequest),
    [checkinsRequest],
  );
  const [loadingPage] = useState(false);

  const initCalendarWeeks = useCallback(
    async (filter?: {manager?: string; user?: string}) => {
      const response = await checkinsController.getCheckinsCalendarWeekList(
        filter,
      );
      setCalendarWeeks(response as any);
      return response;
    },
    [checkinsController, setCalendarWeeks],
  );

  useQuery(
    ['initCalenderWeeks', auth.user.id],
    () =>
      initCalendarWeeks({
        user: auth?.user?.id,
      }),
    {
      retry: false,
    },
  );

  const initKeyResults = useCallback(async () => {
    const request = new GoalsRequestImpl();
    const controller = new GoalsController(request);

    const response = await controller.fetchGoals(1, 'networkAllLevel', 10000);

    return response?.goals;
  }, []);

  return {
    fetchedGoals,
    isFetching: isLoading,
    initKeyResults,
    setSearchValue,
    searchValue,
    data,
    loadingCheckins: loadingPage,
    showUpdateGoalModal,
    refetch,
    handleClose,
  };
}
